import * as types from "../../constants";
import {
  fetchUser as userFetchUser,
  putUserInformation as putUser
} from "../../services/userService";
import { DispatchOf } from "../utils";
import { UserActions } from "../reducers/userReducer";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchUser(user: string, token: string) {
  return async (dispatch: DispatchOf<UserActions> & DispatchOf<ErrorsActions>) => {

    return userFetchUser(user, token)
      .then((response: any) => {
        dispatch({
          type: types.USER_FETCH,
          user: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function updateUser(userId: string, token: string, payload: any) {
  return async (dispatch: DispatchOf<UserActions> & DispatchOf<ErrorsActions>) => {

    return putUser(userId, token, payload)
      .then((response: any) => {
        dispatch({
          type: types.USER_UPDATE,
          user: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearUserError() {
  return (dispatch: DispatchOf<UserActions>) => {
    dispatch({
      type: types.CLEAR_USER_ERROR
    })
  };
}